import { render, staticRenderFns } from "./productConsult.vue?vue&type=template&id=a9f33266&scoped=true&"
import script from "./productConsult.vue?vue&type=script&lang=js&"
export * from "./productConsult.vue?vue&type=script&lang=js&"
import style0 from "./productConsult.vue?vue&type=style&index=0&id=a9f33266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f33266",
  null
  
)

export default component.exports